export default {
    ADD_ALERT: {
        NAME: 'add_alert',
        PATH: 'add_alert',
    },
};
